import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db336008"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-creation-form__content" }
const _hoisted_2 = { class: "user-creation-form__wrapper" }
const _hoisted_3 = { class: "user-creation-form__submit" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Сохранить данные ")

import { onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import type { FormInstance, FormRules } from 'element-plus'
import { ElMessage } from 'element-plus'
import {
  AxiosErrorType,
  CreatedUserType,
  OrganizationType,
  UserInfoType,
} from '@/shared/types'
import { organizationsApi, usersApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import { INPUT_NAMES } from '@/widgets/WUserCreationForm/constants/inputNames'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const userCreationForm = ref<FormInstance>()

const loading = ref(false)

const formInputRefs = reactive({
  nameRef: undefined,
  positionRef: undefined,
  emailRef: undefined,
  roleRef: undefined,
  organizationRef: undefined,
})

const userCreationFormData: UserInfoType = reactive({
  name: '',
  position: '',
  email: '',
  role: 'doktor',
  organizations: [],
})

const userCreationValidationRules = reactive<FormRules>({
  name: [{ required: true, message: 'Введите имя', trigger: 'blur' }],
  position: [{ required: true, message: 'Введите Должность', trigger: 'blur' }],
  email: [
    { required: true, message: 'Введите адрес эл.почты', trigger: 'blur' },
    {
      type: 'email',
      message: 'Некорректный адрес эл.почты',
      trigger: 'blur',
    },
  ],
  role: [
    {
      required: true,
      message: 'Укажите роль',
      trigger: 'blur',
    },
  ],
  organizations: [
    { required: true, message: 'Укажите клиники', trigger: 'blur' },
  ],
})

const organizations = ref<OrganizationType[]>()

const clearForm = (): void => {
  userCreationForm.value.resetFields()
}

const getOrganizations = async (query: string): Promise<void> => {
  loading.value = true

  const [error, response] = await organizationsApi.getOrganizations(query, 50)

  if (error) {
    showErrorMessage(error)
  } else {
    organizations.value = response.data.organizations
    organizations.value.sort((a, b) => {
      if (a.name < b.name) {
        return -1
      }
      if (a.name > b.name) {
        return 1
      }
      return 0
    })
  }

  loading.value = false
}

const createUser = async (): Promise<CreatedUserType> => {
  const [error, response] = await usersApi.createUser(userCreationFormData)

  if (error) {
    const axiosError: AxiosErrorType = {
      errors: [error.errors[0]],
      status: error.status,
    }
    showErrorMessage(axiosError)

    return null
  }

  const createdUser: CreatedUserType = {
    userId: response.data.user.id,
    organizationId: response.data.user.organization[0].id,
  }

  ElMessage({
    message: 'Доктор добавлен',
    type: 'success',
  })

  clearForm()

  return createdUser
}

const handleChangeFocusedInput = (nextInput: string): void => {
  formInputRefs[nextInput].focus()
}

const handleSubmitForm = (): void => {
  if (!userCreationForm.value) return

  userCreationForm.value.validate(async (valid): Promise<boolean> => {
    if (valid) {
      const createdUser = await createUser()

      if (createdUser) {
        router.push({
          name: 'UsersShowPage',
          params: {
            userId: createdUser.userId,
            organizationId: createdUser.organizationId,
          },
        })
      }
    }

    return
  })
}

onMounted((): void => {
  getOrganizations('')
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "userCreationForm",
    ref: userCreationForm,
    model: _unref(userCreationFormData),
    rules: _unref(userCreationValidationRules),
    class: "user-creation-form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "user-creation-form__item",
                    prop: "name",
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (handleChangeFocusedInput(_unref(INPUT_NAMES).position)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "nameRef",
                        modelValue: _unref(userCreationFormData).name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userCreationFormData).name) = $event)),
                        placeholder: "Имя"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "user-creation-form__item",
                    prop: "position",
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (handleChangeFocusedInput(_unref(INPUT_NAMES).email)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "positionRef",
                        modelValue: _unref(userCreationFormData).position,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userCreationFormData).position) = $event)),
                        placeholder: "Должность"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "user-creation-form__item",
                    prop: "email",
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (handleChangeFocusedInput(_unref(INPUT_NAMES).role)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        ref: "emailRef",
                        modelValue: _unref(userCreationFormData).email,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(userCreationFormData).email) = $event)),
                        placeholder: "Эл. адрес"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "user-creation-form__item",
                    prop: "role",
                    onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (handleChangeFocusedInput(_unref(INPUT_NAMES).organization)), ["enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "roleRef",
                        modelValue: _unref(userCreationFormData).role,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(userCreationFormData).role) = $event)),
                        placeholder: "Роль"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Доктор",
                            value: "doktor"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Главный врач",
                            value: "head_doctor"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Администратор",
                            value: "admin"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "user-creation-form__item",
                    prop: "organizations"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "organizationRef",
                        modelValue: _unref(userCreationFormData).organizations,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(userCreationFormData).organizations) = $event)),
                        "collapse-tags": "",
                        "collapse-tags-tooltip": "",
                        filterable: "",
                        remote: "",
                        "remote-show-suffix": "",
                        "remote-method": getOrganizations,
                        loading: loading.value,
                        multiple: "",
                        placeholder: "Клиника"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: organization.name,
                              value: organization.id
                            }, null, 8, ["label", "value"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: "user-creation-form__submit-button",
          round: "",
          type: "primary",
          onClick: handleSubmitForm
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})